export const HHA_PROTOCOL_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Description",
        position: "Certified Home Health Aide",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "POSITION SUMMARY:",
        text: "The Home Health Aide is responsible for providing personal care and related services as assigned on care plan to preserve good patient hygiene and to promote a healthful and safe environment."
    },
    // 2: Essential Duties
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL DUTIES AND RESPONSIBILITIES:",
        duties: [
            "Assists patients with personal hygiene such as skin, mouth, hair care and bathing.",
            "Assists patient in and out of bed and assists with ambulation using good body mechanics.",
            "Assists with prescribed exercises which the patient and aide have been taught by appropriate health professional.",
            "Prepares meals and assists with eating, if needed.",
            "Assists patient with bathroom or commode chair, if needed.",
            "Performs household services essential to health care at home, including but not limited to: light housekeeping, laundry, shopping, errands, and escort services. These services are provided to facilitate self-care and prevent institutionalization.",
            "Assists patient with self-administered medications as allowed by state regulations, such as \"reminders.\" (Does not administer any kind of medication.)",
            "Performs other activities taught by a health professional for a specific patient. These activities include, but are not limited to: changing colostomy bags, non-sterile dressings, taking vital signs, and hygiene care.",
            "Reports changes in patient condition to a nurse or therapist.",
            "Completes records of services, observations, patient condition changes, complaints, intake/output, vital signs, and treatment signs.",
            "Administers personal care services as written by a Case Manager/RN.",
            "Provides physician-ordered services permitted by State law.",
            "Promotes patient comfort.",
            "Contacts RN for emergencies or special instructions.",
            "Performs simple household procedures as an extension of therapy services, such as disposing of infectious secretions, cleaning soiled linen, disposing of food, and light housekeeping.",
            "Attends mandatory in-service educational offerings.",
            "Completes 12 hours of in-services annually.",
            "Attends and participates in case conferences and staff meetings.",
            "Participates in Quality Improvement functions.",
            "Maintains patient information confidentiality.",
            "Prevents infection spread using Standard Precautions.",
            "Follows procedures for charge items and ensures proper billing.",
            "Utilizes patient care equipment and supplies safely and effectively.",
            "Arrives on time for visits or notifies the office of cancellations.",
            "Conforms to all agency policies and procedures."
        ],
        generalStatement: "The following is a representation of the major duties and responsibilities of this position. The Agency will make reasonable accommodations to allow otherwise qualified applicants with disabilities to perform essential functions."
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "QUALIFICATIONS:",
        list: [
            "Current state certificate for Certified Home Health Aide.",
            "Minimum one year current experience in home health or related health care setting.",
            "Knowledge of medical terminology.",
            "Current CPR Certification.",
            "Current and satisfactory report on pre-employment physical examination including Mantoux TB Test or chest X-ray as required by Agency policies and procedures.",
            "Must demonstrate competency by passing written Competency test and demonstrate competency in any service the aide is to perform prior to providing patient care.",
            "Must have a sympathetic attitude toward the sick.",
            "Able to walk, bend, stoop, and lift objects weighing up to 25 lbs.",
            "Able to read, write legibly, spell correctly and perform basic mathematics.",
            "Able to carry out directions.",
            "Be mature and able to deal effectively with the demands of the job.",
            "Possess good organizational skills.",
            "Must be a licensed driver with an automobile that is insured in accordance with state and/or organizational requirements and is in good working order.",
            "Is able to use professional judgment in reporting and seeking assistance from both peers and supervisors."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
